import { type ComponentPropsWithRef, memo } from 'react';
import clsx from 'clsx';

import { LeftCenterIcon } from '@common/svg/icons/components/LeftCenterIcon';
import { RightCenterIcon } from '@common/svg/icons/components/RightCenterIcon';
import styles from '@web/organisms/VideoCarousel/atoms/Arrow/Arrow.module.scss';

export type Direction = 'left' | 'right';

export interface Props extends ComponentPropsWithRef<'li'> {
    direction: Direction;
    isHidden?: boolean;
    onDirectionClick?: (direction: Direction) => void;
}

export const Component = ({ direction, isHidden, onDirectionClick, ...props }: Props) => {
    return (
        <li
            {...props}
            className={clsx(
                styles.Arrow,
                styles[`Arrow-${direction}`],
                isHidden && styles.hidden,
                props.className,
            )}
            onClick={() => {
                if (onDirectionClick) onDirectionClick(direction);
            }}
        >
            {direction === 'left' ? <LeftCenterIcon /> : <RightCenterIcon />}
        </li>
    );
};

Component.displayName = 'Arrow';

export const Arrow = memo(Component);
